export interface DuviNicheSiteFaqItem {
  question: string;
  answer: string;
}

export interface DuviNicheSiteFaqListProps {
  heading: string;
  items: DuviNicheSiteFaqItem[];
}

/**
 * DuviNicheSiteFaqList — ported from the bespoke Fishwalkers design system's
 * `components/marketing/FaqList.jsx`
 * (duvi-design/exports/niches/fishwalkers/system.zip).
 *
 * A definition list with every answer visible, NOT an accordion. That is the
 * design system's explicit constraint ("Static-friendly. Nothing critical to a
 * page may depend on client-side runtime — that includes the FAQ, which is a
 * definition list, not an accordion"), so replacing the previous build's
 * click-to-expand strip is the point of this rebuild rather than a lost
 * feature: the answers now survive a failed hydration and are readable to a
 * crawler without script.
 */
export function DuviNicheSiteFaqList({
  heading,
  items,
}: DuviNicheSiteFaqListProps) {
  return (
    <section className="w-full py-[var(--section-y)] lg:py-[var(--section-y-lg)]">
      <div className="mx-auto w-full max-w-[820px] px-[var(--container-pad)]">
        <h2 className="mb-[var(--space-8)] font-[family-name:var(--font-display)] text-[length:var(--text-h2-sm)] font-extrabold leading-[var(--leading-heading)] tracking-[var(--tracking-heading)] text-[color:var(--heading)] lg:text-[length:var(--text-h2)]">
          {heading}
        </h2>
        <dl className="m-0 flex flex-col">
          {items.map((item) => (
            <div
              key={item.question}
              className="border-t border-[var(--border)] py-[var(--space-6)] last:border-b"
            >
              <dt className="font-[family-name:var(--font-display)] text-[19px] font-bold leading-[var(--leading-heading)] text-[color:var(--heading)]">
                {item.question}
              </dt>
              <dd className="m-0 mt-[var(--space-2)] max-w-[var(--measure-body)] font-[family-name:var(--font-body)] text-[16px] leading-[var(--leading-body)] text-[color:var(--body)]">
                {item.answer}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
